export const hideBanner = (pathName: string) => {
  let ShowBanner = false;
  const bannerHiddenPages = ['search', 'cart', 'product', 'checkout'];
  ShowBanner = bannerHiddenPages?.includes(pathName);
  return ShowBanner;
};
